export const checkOpen = (e, setOpen) => {
  const path = e.nativeEvent.path || (e.nativeEvent.composedPath && e.nativeEvent.composedPath());
  if (path && path.find((el) => el.className === "grey-screen")) setOpen(false);
  else if (path && path.find((el) => el.className === "modal__closeicon")) setOpen(false);
  else if (e.target.textContent === "Save") setOpen(false);
  else if (e.target.textContent === "Discard") setOpen(false);
  else setOpen(true);
};
